import { StandardEvents } from '@shopify/events';
import { sectionRenderer } from '@theme/section-renderer';

// Substrate — free creatine auto-add for subscription carts.
// Adds exactly one $0 creatine (tagged) when the cart contains any subscription line
// and no creatine yet. Removes the tagged gift if no subscription remains.
// The Shopify "Buy X get Y" discount zeroes the line; this only manages presence.

const CRE_VARIANT = 52665659818265;
const GIFT_PROP = '_substrate_gift';
let busy = false;

function jsRoute(route) {
  return route && route.endsWith('.js') ? route : `${route}.js`;
}
async function getCart() {
  const r = await fetch(jsRoute(Theme.routes.cart_url), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  return r.json();
}
function hasSubscription(cart) {
  return cart.items.some((i) => i.selling_plan_allocation);
}
function creatineLines(cart) {
  return cart.items.filter((i) => i.id === CRE_VARIANT);
}
function giftLine(cart) {
  return cart.items.find((i) => i.id === CRE_VARIANT && i.properties && i.properties[GIFT_PROP]);
}
async function addGift() {
  return fetch(jsRoute(Theme.routes.cart_add_url), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ items: [{ id: CRE_VARIANT, quantity: 1, properties: { [GIFT_PROP]: '1' } }] }),
  });
}
async function removeLine(key) {
  return fetch(jsRoute(Theme.routes.cart_change_url), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: key, quantity: 0 }),
  });
}
async function refreshCartSections() {
  const comps = document.querySelectorAll('cart-items-component');
  for (const el of comps) {
    const sid = el.dataset.sectionId;
    if (!sid) continue;
    const mode = el.dataset.drawer !== undefined ? 'hydration' : 'full';
    try {
      await sectionRenderer.renderSection(sid, { cache: false, mode });
    } catch (e) {
      /* view-transition aborts are non-fatal */
    }
  }
}
async function reconcile() {
  if (busy) return;
  busy = true;
  try {
    const cart = await getCart();
    const sub = hasSubscription(cart);
    const cre = creatineLines(cart);
    if (sub && cre.length === 0) {
      await addGift();
      await refreshCartSections();
    } else if (sub && cre.length > 1) {
      const gift = giftLine(cart);
      const manual = cre.find((i) => !(i.properties && i.properties[GIFT_PROP]));
      if (gift && manual) {
        await removeLine(gift.key);
        await refreshCartSections();
      }
    } else if (!sub) {
      const gift = giftLine(cart);
      if (gift) {
        await removeLine(gift.key);
        await refreshCartSections();
      }
    }
  } catch (e) {
    console.warn('[substrate-gift]', e);
  } finally {
    busy = false;
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const p = event && event.promise;
  if (p && typeof p.then === 'function') {
    p.then(() => reconcile()).catch(() => {});
  } else {
    setTimeout(reconcile, 80);
  }
});

if (document.readyState !== 'loading') reconcile();
else document.addEventListener('DOMContentLoaded', reconcile);